import React from 'react';
import { EventBus } from './transformations2/eventBus';

export const NotebookContext = React.createContext<{ eventBus: EventBus }>(null);